import * as React from "react";

const PrintIcon: React.FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.747 4.355H16.24V0H3.759v4.379H1.253C.568 4.379 0 4.946 0 5.633v9.988c0 .686.567 1.255 1.253 1.255H3.76V20h12.483l-.001-3.148h2.506c.685 0 1.253-.568 1.253-1.255V5.61c-.024-.686-.568-1.254-1.253-1.254zM5.627 1.869h8.746v2.51H5.627v-2.51zm8.746 16.238H5.627v-4.38h8.746v4.38zm3.736-3.124h-1.867l-.001-3.125H3.76v3.124H1.892V6.224h16.24v8.759h-.023zM16.24 7.479h-1.867v1.87h1.867v-1.87z" fill="#006AE3" fillRule="nonzero" />
        </svg>
    );
};

export default React.memo(PrintIcon);
